export default "__VITE_ASSET__CO5E$v1G__"